export enum SpaceId {
    VS = 8,
    VSMac = 41,
    DotNet = 61,
    Cpp = 62,
    Ado = 21,
    Tfs = 22,
    Internal = 31,
    OneESCloudMine = 64, 
}
